export const validUOM = (namespace, data, translate) => {
    let error = {};

    switch (namespace) {
        case "uom_name":
            if (!data) {
                error[namespace] = translate("COMMON:REQUIRE", {
                    field: translate("UOM Name"),
                });
            } else if (data.length > 50) {
                error[namespace] = translate("COMMON:CUSTOM_MAX_LENGTH", {
                    max: 50,
                });
            } else {
                error[namespace] = null;
            }
            break;
        case "uom_category_code":
            if (!data) {
                error[namespace] = translate("COMMON:REQUIRE", {
                    field: translate("UOM Category Code"),
                });
            } else if (data.length > 3) {
                error[namespace] = translate("COMMON:MAX_LENGTH", {
                    field: translate("UOM Category Code"),
                });
            } else {
                error[namespace] = null;
            }
            break;
        case "uom_description":
            if (!data) {
                error[namespace] = translate("COMMON:REQUIRE", {
                    field: translate("Description"),
                });
            } else if (data.length > 256) {
                error[namespace] = translate("COMMON:MAX_LENGTH", {
                    field: translate("Description"),
                });
            } else {
                error[namespace] = null;
            }
            break;
        case "uom_category":
            if (!data) {
                error[namespace] = translate("COMMON:REQUIRE", {
                    field: translate("UOM Category"),
                });
            } else {
                error[namespace] = null;
            }
            break;
        case "uom_conversions_to":
            if (!data) {
                error[namespace] = translate("COMMON:REQUIRE", {
                    field: translate("UOM Convers to"),
                });
            } else {
                error[namespace] = null;
            }
            break;
        default:
            break;
    }
    return error;
}